module.exports = new __parcel__URL__("73091286-1.9668e4de.png").toString();